import React, { useState, useEffect, useRef } from "react";
import { Checkbox, TextField } from "@mui/material";
import { saveUserRating } from "../../apiservices/ApiService";
import { getCoachId } from "../../common/Utils";


const ratingOptions = [
  {
    imageUrl: "https://appcdn.goqii.com/storeimg/30674_1733733710.png",
    replaceImg: "https://appcdn.goqii.com/storeimg/14153_1733733726.png", // new image for replacement
    label: "Terrible",
  },
  {
    imageUrl: "https://appcdn.goqii.com/storeimg/25502_1733733750.png",
    replaceImg: "https://appcdn.goqii.com/storeimg/15113_1733733768.png", // new image for replacement
    label: "Bad",
  },
  {
    imageUrl: "https://appcdn.goqii.com/storeimg/24289_1733733781.png",
    replaceImg: "https://appcdn.goqii.com/storeimg/89026_1733733795.png", // new image for replacement
    label: "OK",
  },
  {
    imageUrl: "https://appcdn.goqii.com/storeimg/39909_1733733809.png",
    replaceImg: "https://appcdn.goqii.com/storeimg/75723_1733733823.png", // new image for replacement
    label: "Good",
  },
  {
    imageUrl: "https://appcdn.goqii.com/storeimg/17706_1733733835.png",
    replaceImg: "https://appcdn.goqii.com/storeimg/65597_1733733847.png", // new image for replacement
    label: "Great",
  },
];
const doctorCallRating = [
  {
    "5": [
      { ratingId: "2", description: "Expertise" },
      { ratingId: "11", description: "Probing" },
      { ratingId: "12", description: "Recommendations" },
      { ratingId: "13", description: "Communication" },
      { ratingId: "14", description: "Empathy" },
      { ratingId: "3", description: "Good rapport" },
      { ratingId: "1", description: "Motivation" },
    ],
  },
  {
    "4": [
      { ratingId: "2", description: "Expertise" },
      { ratingId: "12", description: "Recommendations" },
      { ratingId: "13", description: "Communication" },
      { ratingId: "11", description: "Probing" },
      { ratingId: "14", description: "Empathy" },
      { ratingId: "1", description: "Motivation" },
    ],
  },
  {
    "3": [
      { ratingId: "2", description: "Expertise" },
      { ratingId: "12", description: "Recommendations" },
      { ratingId: "13", description: "Communication" },
      { ratingId: "11", description: "Probing" },
      { ratingId: "14", description: "Empathy" },
      { ratingId: "1", description: "Motivation" },
    ],
  },
  {
    "2": [
      { ratingId: "2", description: "Expertise" },
      { ratingId: "12", description: "Recommendations" },
      { ratingId: "13", description: "Communication" },
      { ratingId: "11", description: "Probing" },
      { ratingId: "14", description: "Empathy" },
      { ratingId: "1", description: "Motivation" },
    ],
  },
  {
    "1": [
      { ratingId: "2", description: "Expertise" },
      { ratingId: "12", description: "Recommendations" },
      { ratingId: "13", description: "Communication" },
      { ratingId: "11", description: "Probing" },
      { ratingId: "14", description: "Empathy" },
      { ratingId: "1", description: "Motivation" },
    ],
  },
];

const RatingPopup = ({
  doctorImage,
  doctorName,
  appointmentId,
  onRatingSubmitted,
}) => {
  const [rating, setRating] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [checkedItems, setCheckedItems] = useState({});
  const [ratingImages, setRatingImages] = useState(ratingOptions);

  const popupRef = useRef(null);

  // Get descriptions dynamically based on the rating
  const getDescriptionsByRating = (rating) => {
    const ratingObj = doctorCallRating.find((item) => item[rating]);
    return ratingObj ? ratingObj[rating].map((item) => item.description) : [];
  };

  useEffect(() => {
    // Reset checked items when rating changes
    const descriptions = getDescriptionsByRating(rating);
    setCheckedItems(
      descriptions.reduce((acc, description) => {
        acc[description] = false;
        return acc;
      }, {})
    );
  }, [rating]);

  const handleRatingChange = (index) => {
    setRating(index + 1);
    setRatingImages((prevImages) =>
      prevImages.map((option, i) => {
        if (i === index) {
          return { ...option, imageUrl: option.replaceImg };
        } else {
          return { ...option, imageUrl: ratingOptions[i].imageUrl };
        }
      })
    );

  };

  const handleFeedbackChange = (event) => {
    setFeedback(event.target.value);
  };

  const handleCheckboxToggle = (description) => {
    setCheckedItems((prev) => ({
      ...prev,
      [description]: !prev[description],
    }));
  };
  const handleRatingSubmit = async () => {
    if (!rating) {
      alert("Please select a rating before submitting.");
      return;
    }

    const selectedDescriptions = Object.keys(checkedItems).filter(
      (key) => checkedItems[key]
    );
    const feedbackReasons = selectedDescriptions
      .map((desc) => {
        const ratingItem = doctorCallRating.find((item) =>
          Object.values(item)
            .flat()
            .find((d) => d.description === desc)
        );
        return ratingItem
          ? Object.values(ratingItem)
            .flat()
            .find((d) => d.description === desc)?.ratingId
          : null;
      })
      .filter(Boolean)
      .join(",");

    const feedbackObject = {
      appointmentId,
      goqiiCoachId: getCoachId(),
      feedbackReasons,
      sessionRating: rating.toString(),
      sessionFeedback: feedback,
    };

    try {
      const data = await saveUserRating(feedbackObject);

      // onRatingSubmitted();
    } catch (error) {
      console.error("Error submitting rating:", error);
    }
  };

  const handleOutsideClick = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      onRatingSubmitted();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div ref={popupRef} style={popupStyles.container}>
      <div>
        <button
          onClick={() => onRatingSubmitted()}
          style={popupStyles.closeButton}
        >
          ×
        </button>
        <div style={popupStyles.imageContainer}>
          <img
            src={doctorImage}
            alt={doctorName}
            style={popupStyles.image}
          />
        </div>
        <h3 style={popupStyles.title}>
          Please rate your recent consultation with Dr. {doctorName}
        </h3>
        <div style={popupStyles.ratingOptions}>
          {ratingImages.map((option, index) => (
            <div key={index} style={popupStyles.ratingOption}>
              <img
                src={option.imageUrl}
                alt={option.label}
                style={popupStyles.ratingImage}
                onClick={() => handleRatingChange(index)}
              />
              <div style={popupStyles.ratingLabel}>{option.label}</div>
            </div>
          ))}
        </div>
        {rating && (
          <>
            <h3 style={popupStyles.title}>
              {rating === 5 ? "What did you like the most?" : "What went wrong?"}
            </h3>
            <div style={popupStyles.checkboxContainer}>
              {getDescriptionsByRating(rating).map((description) => (
                <div key={description} style={popupStyles.checkboxWrapper}>
                  <Checkbox
                    id={description}
                    checked={checkedItems[description]}
                    onChange={() => handleCheckboxToggle(description)}
                  />
                  <label htmlFor={description}>{description}</label>
                </div>
              ))}
            </div>
            {/* <div>
              <textarea
                placeholder={feedback}
                value={feedback}
                onChange={handleFeedbackChange}
              ></textarea>
            </div> */}
            <TextField
              placeholder={rating === 5 ? `Give compliment to Dr. ${doctorName}` : "Share your feedback (optional)"}
              multiline
              rows={2}
              fullWidth
              variant="outlined"
              onChange={handleFeedbackChange}
              sx={{ marginTop: 2, marginBottom: 2, borderRadius: 2, fontSize: 10 }}
            />

          </>
        )}
        <button
          style={{
            ...popupStyles.submitButton,
            backgroundColor: rating
              ? popupStyles.submitButton.backgroundColor
              : "gray",
            cursor: rating ? "pointer" : "not-allowed",
            opacity: rating ? 1 : 0.6,
          }}
          onClick={rating ? handleRatingSubmit : null}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default RatingPopup;

const rateDoctorSessionWithRequest = (feedbackObject, callback) => {
  setTimeout(() => {
    const success = true;
    if (success) {
      callback({ success: true }, null);
    } else {
      callback(null, "Failed to submit rating.");
    }
  }, 1000);
};

const popupStyles = {
  container: {
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    backgroundColor: "#fff",
    width: "100%",
    maxWidth: "500px",
    textAlign: "center",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    margin: "0 auto",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    fontSize: "20px",
    background: "transparent",
    border: "none",
    color: "#333",
    cursor: "pointer",
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "10px",
  },
  image: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  title: {
    marginBottom: "20px",
    fontSize: "18px",
    color: "#333",
  },
  ratingOptions: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginBottom: "20px",
    flexWrap: "wrap",
  },
  ratingOption: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  ratingImage: {
    width: "40px",
    height: "40px",
    cursor: "pointer",
    transition: "opacity 0.3s",
  },
  ratingLabel: {
    marginTop: "5px",
    fontSize: "14px",
    color: "#333",
  },
  submitButton: {
    padding: "10px 20px",
    backgroundColor: "#4caf50",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    marginTop: "20px",
  },
  checkboxContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginBottom: "10px",
    width: "100%",
  },
  checkboxWrapper: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: "5px",
  },
};
